export function safeRedirectPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) {
    return null
  }

  // Browsers read \ as / and drop tabs and newlines, so these could become //evil.com
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f]/.test(path)) {
    return null
  }

  if (path === '/login' || path.startsWith('/login?') || path.startsWith('/auth/')) {
    return null
  }

  return path
}
